import { Injectable } from '@angular/core';
import { URLS } from '../constants/constants';
import { HttpService } from './http.service';
import { HeaderType } from '../enums/enums';
import { FilterModel } from '../interface/interface';

export interface ADD_NEWS_PAYLOAD {
  "title": "string",
  "description": "string",
  "img": "string",
  "content": "string",
  "publishedAt": string
} 

@Injectable({
  providedIn: 'root'
})
export class NewsService {

  constructor(private http: HttpService) {}

  addNews(payload: ADD_NEWS_PAYLOAD) {
    return this.http.post(`${URLS.news}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  fetchNewsList(filter: FilterModel) {
    return this.http.get(`${URLS.news}`, {
      params: {
        headerType: HeaderType.ACCESS,
        search: filter.searchText,
        page: filter.pageNumber,
        limit: filter.limit,
      },
    });
  }

  getNewsById(id: string) {
    return this.http.get(`${URLS.news}/${id}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }

  deleteNews(id: string) {
    return this.http.delete(`${URLS.news}/${id}`, {
      params: { headerType: HeaderType.ACCESS },
    });
  }
  
  updateNews(id: string, payload: any) {
    return this.http.put(`${URLS.news}/${id}`, payload, {
      params: { headerType: HeaderType.ACCESS },
    });
  }
}
